import { render, staticRenderFns } from "./Wisdom.vue?vue&type=template&id=313bbe55&scoped=true&"
import script from "./Wisdom.vue?vue&type=script&lang=js&"
export * from "./Wisdom.vue?vue&type=script&lang=js&"
import style0 from "./Wisdom.vue?vue&type=style&index=0&id=313bbe55&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313bbe55",
  null
  
)

export default component.exports